/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import {
  Row, DatePicker, TimePicker, Col,
} from 'antd';
import { DateTime } from 'luxon';
import { PropTypes } from 'prop-types';
import { localToZoneTS, zoneToLocalTS } from '../../../../clock/ManualEntry/manualEntryHelpers';
import { DATE_FORMAT, TIME_FORMAT, TIME_FORMAT_24H } from './TimeEntryTable.constants';
import { luxonToMoment } from './TimeEntryTable.helpers';

function TimeEntryTableDateTimeInput(props) {
  const {
    configProps = {},
    timezone: parentTimezone = DateTime.local().zoneName,
    value,
    onChange,
  } = props;

  const {
    hideDate = false,
    hideTime = false,
    use24HourTime = false,
  } = configProps;

  const {
    date = null,
    time = null,
    timezone = parentTimezone,
  } = value;

  const luxonDate = date
    ? DateTime.fromMillis(zoneToLocalTS(date, timezone))
    : DateTime.local().set({ hour: 0, minute: 0 });
  const luxonTime = time
    ? DateTime.fromMillis(zoneToLocalTS(time, timezone))
    : DateTime.local().set({ hour: 0, minute: 0 });

  const onDateChanged = useCallback((key) => (newDateMoment) => {
    const newDate = newDateMoment
      ? localToZoneTS(newDateMoment.valueOf(), timezone)
      : null;

    onChange({
      ...(value ?? {}),
      [key]: newDate,
    });
  }, [onChange, timezone]);

  return (
    <Row
      gutter={5}
    >
      {!hideDate
        && (
          <Col span={12}>
            <DatePicker
              {...(hideTime && props)}
              style={{
                width: '100%',
              }}
              onChange={onDateChanged('date')}
              value={date ? luxonToMoment(luxonDate) : undefined}
              format={DATE_FORMAT}
            />
          </Col>
        )}

      {!hideTime
        && (
          <Col span={12}>
            <TimePicker
              {...(hideDate && props)}
              style={{
                width: '100%',
              }}
              onChange={onDateChanged('time')}
              value={time ? luxonToMoment(luxonTime) : undefined}
              format={use24HourTime ? TIME_FORMAT_24H : TIME_FORMAT}
              use12Hours={!use24HourTime}
            />
          </Col>
        )}
    </Row>
  );
}

TimeEntryTableDateTimeInput.propTypes = {
  configProps: PropTypes.shape({}),
  timezone: PropTypes.string,
  value: PropTypes.shape({
    date: PropTypes.number,
    time: PropTypes.number,
    timezone: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
};

TimeEntryTableDateTimeInput.defaultProps = {
  configProps: {},
  timezone: DateTime.local().zoneName,
  style: {},
};

export default TimeEntryTableDateTimeInput;
